












import Vue from "vue";
import { computed, defineComponent } from "@vue/composition-api";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { Subscription } from "@teacherskaya/api-provider/dist/api/SubscriptionProvider";
import useRecurring from "@/hooks/useRecurring";
import { $t } from "@/lib/helpers/i18nHelper";
import ProfileRecurringView from "../ProfileRecurringView";

export default defineComponent({
  name: "BlockSubscribers",
  components: { ProfileRecurringView },
  props: {
    user: { type: Object as () => User, required: true },
  },
  setup(props) {
    const { response, subscriptions, onCancel, getRecurringByProvider, getRecurringData } = useRecurring();
    const texts = computed(() => {
      return {
        title: $t("Recently {0}'s {1}", [props.user.screenName, $t("subscribers")]),
        noSubs: $t("No {0} yet", [$t("subscribers")]),
        allSubs: $t("All {0}", [$t("subscribers")]),
      };
    });

    const onCancelRebill = (subscription: Subscription) => {
      onCancel(subscription);
    };
    const onRemoveAccess = (subscription: Subscription) => {
      onCancel(subscription, true);
    };
    const updateSubscriptionList = (addedSubscription: Subscription) => {
      if (response.value !== null) {
        Vue.set(response.value, "result", [addedSubscription, ...response.value.result].slice(0, 3));
      }
    };

    getRecurringData(getRecurringByProvider, props.user.id, 0, 3);

    return {
      texts,
      subscriptions,
      onCancelRebill,
      onRemoveAccess,
      updateSubscriptionList,
    };
  },
});
